import { render, staticRenderFns } from "./NewFolder.vue?vue&type=template&id=0fbd2e5e&"
import script from "./NewFolder.vue?vue&type=script&lang=js&"
export * from "./NewFolder.vue?vue&type=script&lang=js&"
import style0 from "./NewFolder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports